import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { SimpleNotificationsModule } from 'angular2-notifications';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { provideHighlightOptions } from 'ngx-highlightjs';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { interceptFn } from './intercept.interceptor';
import { MasterService } from './master.service';
import { LoaderService } from './loader.service';
import { DatePipe } from '@angular/common'

import { provideAnimations } from '@angular/platform-browser/animations'; // ✅ FIXED: Use `provideAnimations()` instead
  

const highlightOptions = {
  coreLibraryLoader: () => import('highlight.js/lib/core'),
  languages: {
    typescript: () => import('highlight.js/lib/languages/typescript'),
    scss: () => import('highlight.js/lib/languages/scss'),
    xml: () => import('highlight.js/lib/languages/xml')
  },
};

export const appConfig: ApplicationConfig = {
  providers: [MasterService,LoaderService,DatePipe,
    provideHttpClient(withInterceptors([interceptFn])), 
    
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })), 
    provideAnimations(),
    importProvidersFrom([SweetAlert2Module.forRoot(),SimpleNotificationsModule.forRoot()]), // ngx-sweetalert2: https://github.com/sweetalert2/ngx-sweetalert2
    provideHighlightOptions(highlightOptions), // ngx-highlightjs: https://github.com/murhafsousli/ngx-highlightjs
  ],
};
